import * as React from "react";
const SvgFiRrCrab = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-crab_svg__a)">
      <path
        fill="#062147"
        d="m23.707 18.292-.242-.24a6.94 6.94 0 0 0-3.98-1.985c.33-1.032.504-2.1.515-3.067 2.206 0 4-1.794 4-4 0 0-.001-4.6-.003-4.625a3 3 0 0 0-.876-2C22.458 1.71 20.47.54 19.395.052c-.508-.23-1.175.331-.858.79.523.757.888 1.508 1.089 2.224-.671-.208-1.423-.555-2.28-1.034-.486-.272-1.02.35-.79.858.488 1.077 1.659 3.063 2.322 3.726a3 3 0 0 0 3.12.708V9c0 1.103-.896 2-2 2h-.255c-.585-1.977-2.172-3.227-4.744-3.737V6a1 1 0 1 0-2 0v1.025a20.158 20.158 0 0 0-2 0V6a1 1 0 1 0-2 0v1.263c-2.573.51-4.16 1.76-4.744 3.737h-.256c-1.103 0-2-.897-2-2V7.325a3 3 0 0 0 3.12-.708c.664-.663 1.835-2.649 2.322-3.726.23-.508-.303-1.13-.79-.858-.856.48-1.607.825-2.28 1.034.202-.715.567-1.466 1.09-2.224.317-.459-.35-1.02-.858-.79C3.528.541 1.54 1.713.879 2.374a2.99 2.99 0 0 0-.876 2.001C0 4.4 0 9 0 9c0 2.206 1.794 4 4 4 .013.873.21 1.964.589 3.057A6.95 6.95 0 0 0 .535 18.05l-.243.242A.999.999 0 0 0 .999 20c.256 0 .51-.098.707-.292l.244-.243A4.97 4.97 0 0 1 5.476 18c.512.875 1.156 1.653 1.929 2.198-.981.782-1.817 1.734-2.173 2.161a1 1 0 0 0 1.536 1.281C7.942 22.234 9.453 21 10 21h4c.547 0 2.058 1.233 3.232 2.64a1 1 0 0 0 1.409.127 1 1 0 0 0 .127-1.408c-.351-.42-1.165-1.349-2.126-2.124.81-.54 1.477-1.327 1.999-2.234a4.97 4.97 0 0 1 3.41 1.464l.243.242a1 1 0 0 0 1.414-1.416zM14.154 19H9.846C7.453 19 6 14.77 6 12.91 6 10.975 6.713 9 12 9s6 1.977 6 3.91c0 2.185-1.285 6.09-3.846 6.09"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-crab_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCrab;
